export default __webpack_public_path__ + "static/media/main-icon.ac8191dd.svg";